module.exports = __webpack_public_path__ + "img/gold2.1a58a8ea.png";